import { Router } from '@angular/router';
import { NavigationService } from './../navigation.service';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss']
})
export class ModalContentComponentBusRes {
  type: number;
  qty: number;

  ibox: number;
  pounds: number;

  constructor(
    public activeModal: NgbActiveModal,
    public nav: NavigationService,
    private router: Router,

    private location: Location
  ) { }

  iboxIsSet(): boolean {
    return typeof (this.ibox) !== 'undefined';
  }

  log(event: any) {
    console.log(event);
  }

calculate() {
  const factor = [];
  // individual elements set to make it easier to see what index goes with which factor
  factor[0] = 1;
  factor[1] = 120;
  factor[2] = 250;
  factor[3] = 500;
  factor[4] = 50;
  factor[5] = 60;
  factor[6] = 72;
  factor[7] = 7;
  factor[8] = 10;
  factor[9] = 7;
  factor[10] = 10;
  factor[11] = 2;
  factor[12] = 2;
  factor[13] = 1;
  factor[14] = 0.5;
  factor[15] = 1;
  factor[16] = 0.333;
  factor[17] = 1;
  factor[18] = 1.7;
  factor[19] = 2.1;
  if (typeof (this.qty) !== 'undefined' && typeof (this.type) !== 'undefined') {
    const box = this.qty * factor[this.type];
    this.ibox = Math.ceil(box);
    this.pounds = this.ibox * 30;
    const price = box <= 10 ? 150 : (150 + ((box - 10) * 10));
    this.navigateTo(this.ibox);
  }
  console.log([this.qty, this.type, 1]);
}

navigateTo(boxes: number) {
  // set the state namber of boxes then navigate to appropriate route
  const to = [];
  if (boxes <= 1) {
    to.push('/action', 'paper-retail');
    this.nav.updateState('businessResidential', 'A few boxes');
  } else if (boxes <= 3) {
    to.push('/action', 'paper-retail');
    this.nav.updateState('businessResidential', '1 to 3 boxes');
  } else if (boxes < 11) {
    to.push('/config', 'witness-prompt');
    this.nav.updateState('businessResidential', '4 to 9 boxes');
  } else {
    to.push('/action', 'paper');
    this.nav.updateState('businessResidential', '10 or more boxes');
  }
  // dismiss modal
  // after modal dismisal, navigate to
  setTimeout(() => {
    this.activeModal.close(boxes + ' boxes');
    setTimeout(() => {
      this.router.navigate(to);
    }, 500);
  }, 1000);
}
}

@Component({
  selector: 'app-bus-res',
  templateUrl: './bus-res.component.html',
  styleUrls: ['./bus-res.component.scss']
})
export class BusResComponent implements OnInit {
  images = [
    this.nav.assets + 'boxes.svg',
    this.nav.assets + 'cabinet.svg',
    this.nav.assets + 'pile.svg'
  ];
  closeResult: string;

  constructor(
    public nav: NavigationService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  open() {
    const modalRef = this.modalService.open(ModalContentComponentBusRes, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'lg',
      windowClass: 'calc'
    }
    );
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onClick(boxes) {
    this.nav.updateState('busRes', boxes);
  }

}
